import { ECustomerSearchTypes } from 'v2/interfaces/reports/partnerCommissions';
import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  commissioned: yup
    .string()
    .nullable()
    .when('commissioned_type', {
      is: ECustomerSearchTypes.EMAIL,
      then: yup.string().email('Campo não é um e-mail válido')
    })
    .when('commissioned_type', {
      is: ECustomerSearchTypes.NAME,
      then: yup.string().min(5, 'Insira pelo menos 5 caracteres')
    })
});
